import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MerchantsApi } from '../../Apis/merchantsApi';

// Async Thunk to fetch approved merchants
export const fetchApprovedMerchants = createAsyncThunk(
  'merchants/fetchApprovedMerchants',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await MerchantsApi.listApprovedMerchants();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred in fetching merchants");
    }
  }
);
const initialState= {
  merchants: [],
  loading: false,
  error: null,
}
const merchantSlice = createSlice({
  name: 'merchants',
  initialState,
  reducers: {
    resetMerchant: ()=> initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovedMerchants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovedMerchants.fulfilled, (state, action) => {
        state.loading = false;
        state.merchants = action.payload;
      })
      .addCase(fetchApprovedMerchants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetMerchant } = merchantSlice.actions;
export default merchantSlice.reducer;